import React, { useState } from "react";
import NameColorTable, { NameColorData } from "../../../Common/name-color-table/name-color-table.component";
import NameColorRow from "../../../Common/name-color-table/name-color-row.component";
import DisableStatusModal from "./disable-status-modal/disable-status-modal.component";
import DeleteStatusModal from "./delete-status-modal/delete-status-modal.component";
import { Flaggers } from "../../../../common/store/flaggers/flaggers.enum";
import { mockStatusesData } from "./statuses.mock-data";

const StatusesTable = () => {
  const [statuses, setStatuses] = useState<NameColorData[]>(mockStatusesData);

  return (
    <NameColorTable
      data={statuses}
      onDataChange={setStatuses}
      firstColumnLabel="Status"
      disableModalFlagger={Flaggers.DisableToggleTagModalFlagger}
      deleteModalFlagger={Flaggers.DeleteTagModalFlagger}
      renderRow={(props) => <NameColorRow key={props.item.id} {...props} />}
      renderDisableModal={(props) => (
        <DisableStatusModal
          {...props}
        />
      )}
      renderDeleteModal={(props) => (
        <DeleteStatusModal
          {...props}
        />
      )}
    />
  );
};

export default StatusesTable;

